import {Helmet} from "react-helmet";
import React from "react";
import CustomBtn from "../component/customBtns/CustomBtn";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@mui/material/TablePagination";
import jwtInterceptor from "../service/jwtInterceptor";
import {API_URL} from "../utils/constants";
import AgenceTableRow from "../component/AgenceTableRow";
import {Box} from "@mui/material";
import Modal from "@mui/material/Modal";
import SuperAdminAgenceContainer from "./SuperAdminAgenceContainer";
import {InscriptionAgenceAdmin} from "../pages/inscription/InscriptionAgenceAdmin";

export const AgenceContainer = () => {
    const [data, setData] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [openCreateAgenceModal, setOpenCreateAgenceModal] = React.useState(false);
    const [selectedAgence, setSelectedAgence] = React.useState(null);
    const [error, setError] = React.useState(null);
    const [selectedAgenceId, setSelectedAgenceId] = React.useState(null);

    const columns = [
        {accessor: "nom", show: "Nom"},
        {accessor: "address", show: "Adresse"},
        {accessor: "phone", show: "Téléphone"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date création"},
        {accessor: "updatedAt", show: "Date modification"},
    ];

    const getData = React.useCallback(async (page = 0, size = 10) => {
        try {
            const response = await jwtInterceptor.get(`${API_URL}/agence?pageNumber=${page}&pageSize=${size}`);
            if (response.data && response.data.data) {
                setData(response.data.data.records || []);
                setTotal(response.data.data.totalCount || 0);
            } else {
                setData([]);
                setTotal(0);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des agences:", error);
            setData([]);
            setTotal(0);
        }
    }, []);

    React.useEffect(() => {
        getData(page, rowsPerPage);
    }, [getData, page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = async (id) => {
        try {
            await jwtInterceptor.delete(`${API_URL}/agence/${id}`);
            getData(page, rowsPerPage);
        } catch (error) {
            console.error("Erreur lors de la suppression de l'agence:", error);
        }
    };

    const handleEdit = () => {
        getData(page, rowsPerPage);
    };

    const handleEditAgence = (agence) => {
        setSelectedAgence(agence);
        setOpenCreateAgenceModal(true);
    };

    const onCloseCreateAgence = () => {
        setOpenCreateAgenceModal(false);
        setSelectedAgence(null);
        getData(page, rowsPerPage);
    };

    const handleRowClick = (agence) => {
        console.log("Agence sélectionnée:", agence);
        console.log("Agence sélectionnée par Id:", agence._id);
        if (agence && agence._id) {
            setSelectedAgenceId(agence._id);
        } else {
            console.log('selectedAgence :', selectedAgence)
        }
    };

    const handleBackToList = () => {
        setSelectedAgenceId(null);
    };

    /****Custom variable styles */
    const fontWeightTitle = {
        fontWeight: "600",
    };

    if (selectedAgenceId) {
        return (
            <div>
                <button
                    onClick={handleBackToList}
                    className="btn btn-link px-5 pt-3"
                >
                    ← Retour à la liste des agences
                </button>
                <SuperAdminAgenceContainer agenceId={selectedAgenceId}/>
            </div>
        );
    }

    return (
        <div className="my-4 px-4">
            <Helmet>
                <title>Gérer les agences - Mixdata</title>
            </Helmet>
            <Paper className="py-4 px-4 rounded shadow-none App-container sw-100 m-0">
                <div className="d-flex justify-content-between">
                    <h3
                        className="mb-4"
                        style={{...fontWeightTitle, width: "fit-content"}}
                    >
                        Agence(s)
                    </h3>
                    <div style={{width: "fit-content"}}>
                        <CustomBtn
                            label="Agence"
                            bgColor="#299CDB"
                            iconBg={"#3ba9e5"}
                            icon={"+"}
                            click={() => setOpenCreateAgenceModal(true)}
                        />
                    </div>
                </div>
                {error ? (
                    <div className="alert alert-warning" role="alert">
                        {error}
                    </div>
                ) : (
                    <>
                        <div className="overflow-auto">
                            <table className="table" style={{margin: "auto"}}>
                                <thead
                                    style={{
                                        background: "#eeeeee",
                                        borderBottom: "2px #DEE2E6 solid",
                                        fontWeight: "normal",
                                        color: "#363636",
                                        marginBottom: "5px",
                                    }}
                                >
                                <tr style={{width: "100%"}}>
                                    {columns.map((field) => (
                                        <th
                                            style={{width: "16.66%"}}
                                            scope="col"
                                            key={field.accessor}
                                        >
                                            {field.show}
                                        </th>
                                    ))}
                                    <th style={{width: "7.66%"}} scope="col" key={"actions"}>
                                        Action
                                    </th>
                                </tr>
                                </thead>
                                <tbody style={{paddingInline: "5px"}}>
                                {data && data.length > 0 ? (
                                    data.map((row, index) => (
                                        <AgenceTableRow
                                            key={row._id}
                                            row={row}
                                            keyIndex={index}
                                            onDelete={handleDelete}
                                            onEdit={handleEdit}
                                            onClick={handleRowClick}
                                        />
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center">
                                            Aucune agence trouvée
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        <TablePagination
                            component="div"
                            count={total}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Lignes par page"
                            labelDisplayedRows={({from, to, count}) => `${from}-${to} sur ${count}`}
                            backIconButtonProps={{
                                "aria-label": "Précédent",
                                className: "PreviousBtn",
                            }}
                            nextIconButtonProps={{
                                "aria-label": "Suivant",
                                className: "NextBtn",
                            }}
                        />
                    </>
                )}
                <Modal
                    open={openCreateAgenceModal}
                    onClose={onCloseCreateAgence}
                >
                    <Box
                        className="w-50 h-auto rounded p-3"
                        style={{height: "fit-content"}}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <InscriptionAgenceAdmin
                            onClose={onCloseCreateAgence}
                            onSuccess={() => getData(page, rowsPerPage)}
                            isModal={true}
                        />
                    </Box>
                </Modal>
            </Paper>
        </div>
    )
}